<div class="banner-container">
    
    <div id="BannerCarousel" class="carousel slide carousel-fade" data-bs-ride="carousel" data-bs-touch="false">
        <div class="carousel-inner">
            
            @for (banner of banners; track $index) {
                <div class="carousel-item" [ngClass]="{'active': $index == 0}"  data-bs-interval="15000">
                    <a [href]="banner.url" target="_blank"><img [src]="banner.src" [alt]="banner.alt" loading="{{$index === 0 ? 'eager' : 'lazy'}}" width="1000" height="250" /></a>
                </div>
            }

        </div>
    </div>

</div>